/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const newsletterForm = {
	submit: document.getElementById("Subscribe"),
	result: document.getElementById("result"),
	success: document.querySelector(".newsletter__form-message"),
	email: document.getElementById("Email"),
	clickInput: clickInput
}

const promoForm = {
	submit: document.getElementById("promo-subscribe"),
	result: document.getElementById("promo_result"),
	success: document.querySelector(".promo-pop__form-message"),
	email: document.getElementById("PromoEmail"),
	clickInput: clickInput
}

const contactForm = {
	submit: document.getElementById("Enquiry"),
	result: document.getElementById("submit-result"),
	success: document.querySelector(".page__contact-form__note"),
	email: document.getElementById("ContactFormEmail"),
	inputs: document.querySelectorAll('.page__contact-form__input__required'),
	clickInput: clickInput
}

function init() {
 	detectCaptcha();
 	newsletterForm.clickInput();
 	promoForm.clickInput();
 	contactForm.clickInput();
 	// inputMessage(contactForm);
 };

 

function clickInput() {
	if (this.submit) {
		this.submit.addEventListener('click', (evt) => {
			if (!validateEmail(this.email.value)) { 
		    	console.log(this.email);
		    	this.email.style.borderColor = '#D68663';
		    	this.email.style.boxShadow = 'none';
			  	evt.preventDefault();
			    this.result.classList.add('newsletter__error');
			    this.success.style.display = "none";
			    this.email.classList.add('email__error'); 
		  	}

		});
	};
	
	 
};

init();

// function inputMessage(form) {
	
// 		form.submit.addEventListener('click', function(evt) {
// 			form.inputs.forEach(function(input) {
				
// 			const message = document.getElementById(input.dataset.error);
// 			if (input.value === '') {
// 				message.style.display = "inline-block";
// 				evt.preventDefault();
// 			} else {
// 				message.style.display = "none";
// 			}
// 			});
// 		});	
		
		
	
// }

 
// const capcha = document.querySelector('.shopify-challenge__container');
// const mainContent = document.querySelector('.main');
// console.log(!!capcha);

// if (!!capcha) {
// 	capcha.scrollTop = -300;	
// };

const contactInput = document.querySelectorAll('.page__contact-form__input');

contactInput.forEach(function(input) {
	const idInput = input.dataset.inputNum;
	const inputLabel = document.getElementById(idInput);
	if (input.value != '') {
		inputLabel.classList.add('labelUp');
	}
	input.addEventListener('change', () => {
		if (input.value != '') {
			inputLabel.classList.add('labelUp');
		} else {
			inputLabel.classList.remove('labelUp');
		}
	});
});

function detectCaptcha() {
	
	if (window.location.pathname === "/challenge") {	
		const mainContent = document.querySelector('.shopify-challenge__message');
		const promoPop = document.querySelector('.promo-pop');
         mainContent.scrollIntoView(true);
         promoPop.style.display = "none";
         
	}
	console.log(window.location.pathname === "/challenge");
	
}

$(document).ready(function() {
  $('.slick-home').slick({
    slidesToShow: 4,
    infinite: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M13.6 9.00001L7.99997 14.7" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.6 20.3L7.99997 14.7" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.3 14.7L8.29999 14.7" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0"><rect x="23.3" y="21.3" width="16.3" height="13.3" transform="rotate(180 23.3 21.3)" fill="white"/></clipPath></defs></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M16.7 20.3L22.3 14.6" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.7 9L22.3 14.6" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 14.6H22" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0"><rect x="7" y="8" width="16.3" height="13.3" fill="white"/></clipPath></defs></svg></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
    ]
  });
  
  // Scroll when filter is active
  setTimeout(function(e) {
    var url_parts = window.location.pathname.split("/");
    if (url_parts.length >= 4 && url_parts[1] == "collections") {
      window.scrollTo({top: $('#collection-main').offset().top - $("#top").height()});
    }
  }, 10)
  
  // For Gift cards
  var design_selected_src = $("#gift-card-preview-design").attr("src");
  $("#diseno").val("https:" + design_selected_src);
  $(".design-image-container img[src='" + design_selected_src + "']").addClass("active");
  $(".design-image-container img").click(function(e) {
    $(".design-image-container img.active").removeClass("active");
    $("#gift-card-preview-design").attr("src", $(this).attr("src"));
    $("#diseno").val("https:" + $(this).attr("src"));
    $(this).addClass("active")
  });
  
  /*
  $("#monto").change(function(e) {
    $("#giftcard-field-price").val($(this).val());
  })
  $(".js-giftcard-price").click(function(e) {
    var price = $(this).attr("data-price");
    if ($(this).attr("id") == "gift-card-other-price-button") {
      price = $("#monto").val();
    }
    console.log(price);
    
    if (!$(this).hasClass("active")) {
      $(".js-giftcard-price.active").removeClass("active");
      $(this).addClass("active");
      if ($(this).attr("id") == "gift-card-other-price-button") {
      	$("#gift-card-other-price-input").css("display", "inline-block");
      } else {
        $("#gift-card-other-price-input").hide();
        $("#monto").val("");
      }
    }
    
    $("#giftcard-field-price").val(price);
  });
  */
  
  if ($("#ergopouch-gift-card").length) {
    $("#datepicker-gift-card").datepicker({
      autoComplete: true,
      changeMonth: true,
      changeYear: true,
      create: null,
      currentText: "Go Today",
      dateFormat: "mm/dd/yy", 
      disabled: false,
      minDate: "'0d'",
      showButtonPanel: true,
      firstDay: 1,

      // Localization
      closeText: "Cerrar",
      prevText: "&#x3C;Ant",
      nextText: "Sig&#x3E;",
      currentText: "Hoy",
      monthNames: [ "Enero","Febrero","Marzo","Abril","Mayo","Junio",
      "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre" ],
      monthNamesShort: [ "Ene","Feb","Mar","Abr","May","Jun",
      "Jul","Ago","Sep","Oct","Nov","Dic" ],
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      weekHeader: "Sm",
      dateFormat: "dd/mm/yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: "",
    });
    $(".field-fecha-de-envio-icon").click(function() {
      $("#datepicker-gift-card").datepicker("show");
    });
    $(".validate-payment-form .shopify-payment-button").click(function(e) {
      var formId = $(this).parents(".validate-payment-form").attr("data-form-id");
      if (!$("#" + formId)[0].checkValidity()) {
        e.preventDefault();
        return false;
      }
    });
  }
});